import { DocumentNode, gql } from '@apollo/client'

export const UPDATE_SECTION_GROUP: DocumentNode = gql`
    mutation UpdateSectionGroup($sectionGroupId: Int!, $sectionGroup: SectionGroupInput!, $daycareId: Int!) {
        updateSectionGroup(sectionGroupId: $sectionGroupId, sectionGroup: $sectionGroup, daycareId: $daycareId) {
            id
            name
            sections
            rate
        }
    }
`

export const CREATE_SECTION_GROUP: DocumentNode = gql`
    mutation CreateSectionGroup($daycareId: Int!, $sectionGroup: SectionGroupInput!) {
        createSectionGroup(daycareId: $daycareId, sectionGroup: $sectionGroup) {
            id
            name
            sections
            rate
        }
    }
`

export const DELETE_SECTION_GROUP: DocumentNode = gql`
    mutation DeleteSectionGroup($sectionGroupId: Int!, $daycareId: Int!) {
        deleteSectionGroup(sectionGroupId: $sectionGroupId, daycareId: $daycareId)
    }
`

export const SET_SECTION_GROUP_TO_SECTION: DocumentNode = gql`
    mutation SetSectionGroupToSection($sectionGroupId: Int!, $sectionId: Int!, $daycareId: Int!) {
        setSectionGroupToSection(sectionGroupId: $sectionGroupId, sectionId: $sectionId, daycareId: $daycareId)
    }
`

export const GET_SECTION_GROUPS: DocumentNode = gql`
    query GetSectionGroups($daycareId: Int!) {
        getSectionGroups(daycareId: $daycareId) {
            id
            name
            sections
            rate
        }
    }
`

export const GET_RATE_SLOTS_AND_SLOTS: DocumentNode = gql`
    query GetRateSlotsAndSlots($daycareId: Int!, $date: Date!, $sectionIds: [Int]) {
        getRateSlotsAndSlots(daycareId: $daycareId, date: $date, sectionIds: $sectionIds) {
            rate {
                start
                end
                hasRequiredStaff
                childs {
                    childId
                    childName
                    parentId
                    occasionalSlots {
                        id
                        daycareId
                        sectionId
                        childId
                        childName
                        childComplement
                        parentName
                        parentId
                        section
                        parentComment
                        date
                        start
                        end
                        type
                        matching
                        limit {
                            childId
                            limit
                        }
                        scheduled
                        expiry
                        created
                        updated
                        internalNote
                        externalNote
                        externalIcon
                        placeId
                        placeName
                        placeAddress
                    }
                    regularSlots {
                        id
                        daycareId
                        childName
                        childComplement
                        childId
                        sectionId
                        sectionName
                        day
                        start
                        end
                        date
                        parentId
                        parentName
                        absence
                        parentComment
                        daycareComment
                        type
                        cancellationRequests {
                            id
                            date
                            start
                            end
                            reason
                            requestDate
                        }
                        placeId
                        placeName
                        placeAddress
                        created
                        updated
                    }
                }
                staffs {
                    staffId
                    staffName
                    self
                    works {
                        id
                        daycareId
                        date
                        start
                        end
                        staff
                        staffName
                        staffLevelId
                        type
                        sectionGroupId
                        sectionGroupName
                        internalNote
                        externalNote
                    }
                }
                available
                realRate
                potentialRate
                type
            }
            availableSlots {
                id
                daycareId
                sectionId
                childId
                childName
                childComplement
                parentName
                parentId
                section
                parentComment
                date
                start
                end
                type
                matching
                scheduled
                expiry
                created
                updated
                internalNote
                externalNote
                externalIcon
                placeId
                placeName
                placeAddress
            }
            childs {
                childId
                childName
                parentId
                occasionalSlots {
                    id
                    daycareId
                    sectionId
                    childId
                    childName
                    childComplement
                    parentName
                    parentId
                    section
                    parentComment
                    date
                    start
                    end
                    type
                    matching
                    limit {
                        childId
                        limit
                    }
                    scheduled
                    expiry
                    created
                    updated
                    internalNote
                    externalNote
                    externalIcon
                    placeId
                    placeName
                    placeAddress
                }
                regularSlots {
                    id
                    daycareId
                    childName
                    childComplement
                    childId
                    sectionId
                    sectionName
                    day
                    start
                    end
                    date
                    parentId
                    parentName
                    absence
                    parentComment
                    daycareComment
                    type
                    cancellationRequests {
                        id
                        date
                        start
                        end
                        reason
                        requestDate
                    }
                    placeId
                    placeName
                    placeAddress
                    created
                    updated
                }
            }
            staffs {
                staffId
                staffName
                self
                works {
                    id
                    daycareId
                    date
                    start
                    end
                    staff
                    staffName
                    staffLevelId
                    type
                    sectionGroupId
                    sectionGroupName
                    internalNote
                    externalNote
                    preparationTimeBefore
                    preparationTimeAfter
                    preparationTasksBefore {
                        id
                        daycareId
                        name
                        duration
                    }
                    preparationTasksAfter {
                        id
                        daycareId
                        name
                        duration
                    }
                    totalDuration
                }
            }
            closingDay
        }
    }
`

export const GET_RATE_SLOTS: DocumentNode = gql`
    query GetRateSlots($daycareId: Int!, $from: Date!, $to: Date!) {
        getRateSlots(daycareId: $daycareId, from: $from, to: $to) {
            rate {
                start
                end
                hasRequiredStaff
                childs {
                    childId
                    childName
                    parentId
                    occasionalSlots {
                        id
                        daycareId
                        sectionId
                        childId
                        childName
                        childComplement
                        parentName
                        parentId
                        section
                        parentComment
                        date
                        start
                        end
                        type
                        matching
                        limit {
                            childId
                            limit
                        }
                        scheduled
                        expiry
                        created
                        updated
                        internalNote
                        externalNote
                        externalIcon
                        placeId
                        placeName
                        placeAddress
                    }
                    regularSlots {
                        id
                        daycareId
                        childName
                        childComplement
                        childId
                        sectionId
                        sectionName
                        day
                        start
                        end
                        date
                        parentId
                        parentName
                        absence
                        parentComment
                        daycareComment
                        type
                        cancellationRequests {
                            id
                            date
                            start
                            end
                            reason
                            requestDate
                        }
                        placeId
                        placeName
                        placeAddress
                        created
                        updated
                    }
                }
                staffs {
                    staffId
                    staffName
                    self
                    works {
                        id
                        daycareId
                        date
                        start
                        end
                        staff
                        staffName
                        staffLevelId
                        type
                        sectionGroupId
                        sectionGroupName
                        internalNote
                        externalNote
                    }
                }
                available
                realRate
                potentialRate
                type
            }
            date
            start
            end
            sectionGroupId
            sectionGroupName
        }
    }
`
